import { Item } from "@react-stately/collections";
function TombacItem(_props) {
  return null;
}
TombacItem.getCollectionNode = function* getCollectionNode(props, context) {
  /*
    For some unknown reason, React Aria's creators decided to hide
    the `getCollectionNode` function from the public API, even though
    it's part of the interface required for implementing a custom collection.
  */
  // @ts-expect-error -- See above
  yield* Item.getCollectionNode({
    ...props,
    // We use `disabled` instead of `isDisabled` in our existing components
    isDisabled: props.disabled
  }, context);
};
export { TombacItem };
//# sourceMappingURL=TombacItem.js.map